import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeEsMx from '@angular/common/locales/es-MX';
import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withNavigationErrorHandler,
} from '@angular/router';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { reloadOnChunkError } from './core/router/chunk-reload';

registerLocaleData(localeEsMx);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // `withNavigationErrorHandler` recupera la navegación cuando el chunk de
    // una ruta diferida da 404 por un despliegue nuevo (ver chunk-reload.ts).
    provideRouter(
      routes,
      withComponentInputBinding(),
      withNavigationErrorHandler(reloadOnChunkError),
    ),
    // Orden importante: `errorInterceptor` envuelve a `authInterceptor`, que
    // queda más cerca del backend. Así un 401 lo ve primero el de auth (que
    // renueva el token y reintenta) y solo si eso falla llega al de errores,
    // que cierra la sesión y manda a login.
    provideHttpClient(withInterceptors([errorInterceptor, authInterceptor])),
    { provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'MXN' },
  ],
};
